'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'sword';
var width = 576;
var height = 512;
var aliases = [128481];
var unicode = 'f71c';
var svgPathData = 'M464-16l-262.1 262.1 96 96 262.1-262.1 0-96-96 0zM0 448l96 96 32-32 0-48 48-48 112 48 32-32-208-208-32 32 48 112-48 48-48 0-32 32z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSword = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;